import { Article, Category } from '@wix/answers-api';
import { FunctionComponent } from 'react';

import { ArticleList } from '../ArticleList';

export type LeafCategoryPageProps = {
  category: Category;
  categoryArticles?: Article[];
};

export const LeafCategoryPage: FunctionComponent<LeafCategoryPageProps> = ({
  category,
  categoryArticles,
}) => <ArticleList category={category} categoryArticles={categoryArticles} />;
